/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Success_Verify_EmailInputs */

const en_login_success_verify_email = /** @type {(inputs: Login_Success_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please verify your email address before continuing.`)
};

const fr_login_success_verify_email = /** @type {(inputs: Login_Success_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez vérifier votre adresse email avant de continuer.`)
};

const de_login_success_verify_email = /** @type {(inputs: Login_Success_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte überprüfen Sie Ihre E-Mail-Adresse, bevor Sie fortfahren.`)
};

const it_login_success_verify_email = /** @type {(inputs: Login_Success_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica il tuo indirizzo email prima di continuare.`)
};

const ru_login_success_verify_email = /** @type {(inputs: Login_Success_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, подтвердите свой адрес электронной почты, прежде чем продолжить.`)
};

const es_login_success_verify_email = /** @type {(inputs: Login_Success_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor verifique su dirección de correo electrónico antes de continuar.`)
};

const zh_cn2_login_success_verify_email = /** @type {(inputs: Login_Success_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先验证您的电子邮件地址再继续。`)
};

const ja_login_success_verify_email = /** @type {(inputs: Login_Success_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続行する前にメールアドレスを確認してください。`)
};

const hi_login_success_verify_email = /** @type {(inputs: Login_Success_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगे बढ़ने से पहले कृपया अपना ईमेल पता सत्यापित करें।`)
};

const pt_pt2_login_success_verify_email = /** @type {(inputs: Login_Success_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, verifique seu endereço de e-mail antes de continuar.`)
};

/**
* | output |
* | --- |
* | "Please verify your email address before continuing." |
*
* @param {Login_Success_Verify_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_success_verify_email = /** @type {((inputs?: Login_Success_Verify_EmailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Success_Verify_EmailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_success_verify_email(inputs)
	if (locale === "de") return de_login_success_verify_email(inputs)
	if (locale === "it") return it_login_success_verify_email(inputs)
	if (locale === "ru") return ru_login_success_verify_email(inputs)
	if (locale === "es") return es_login_success_verify_email(inputs)
	if (locale === "zh-CN") return zh_cn2_login_success_verify_email(inputs)
	if (locale === "ja") return ja_login_success_verify_email(inputs)
	if (locale === "hi") return hi_login_success_verify_email(inputs)
	if (locale === "pt-PT") return pt_pt2_login_success_verify_email(inputs)
	return en_login_success_verify_email(inputs)
});